module.exports = __webpack_public_path__ + "static/media/logohome.6e77eb21.png";